import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IEmployeeReport } from 'src/app/shared/interfaces/employee-report/iemployeereport';
import { EmployeeReportActions } from 'src/app/store/employee-report/employee-report.actions';
import { selectEmployeeReport } from 'src/app/store/employee-report/employee-report.selectors';

@Component({
  selector: 'app-employee-report',
  templateUrl: './employee-report.component.html',
  styleUrls: ['./employee-report.component.scss']
})
export class EmployeeReportComponent implements OnInit {

  applyFilterUnidade: boolean = false
  applyFilterUnidadeRelatorioFuncionario: boolean = false

  employeeReport$ = this.store.select(selectEmployeeReport)

  constructor(
    private fb: FormBuilder,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.store.dispatch(EmployeeReportActions.loadEmployeeReport())

    this.employeeReport$.subscribe({
      next: (res: IEmployeeReport) => {

        if (res != null || undefined) {
          this.form.setValue({
            agendamento_funcionario: res.agendamento_funcionario,
            avaliacoes_antes_de_tres_horas: res.avaliacoes_antes_de_tres_horas,
            entrega_de_exames: res.entrega_de_exames,
            media_resolucoes_enviadas: res.media_resolucoes_enviadas,
            relatorio_por_funcionario: res.relatorio_por_funcionario,
            total_relatorio_por_funcionario: res.total_relatorio_por_funcionario
          })

          /* console.log("form after setValue:", this.form.value) */

        }
      }
    })
  }

  filtroUnidade = [
    {
      label: 'Vila Nova',
      command: () => {
        this.addFilterUnidade('Vila Nova');
      }
    },
    {
      label: 'Barreiro',
      command: () => {
        this.addFilterUnidade('Barreiro');
      }
    },
    {
      label: 'Belo Horizonte',
      command: () => {
        this.addFilterUnidade('Belo Horizonte');
      }
    }
  ]

  filtroUnidadeRelatorioFuncionario = [
    {
      label: 'Vila Nova',
      command: () => {
        this.addFilterUnidadeRelatorioFuncionario('Vila Nova');
      }
    },
    {
      label: 'Barreiro',
      command: () => {
        this.addFilterUnidadeRelatorioFuncionario('Barreiro');
      }
    },
    {
      label: 'Belo Horizonte',
      command: () => {
        this.addFilterUnidadeRelatorioFuncionario('Belo Horizonte');
      }
    },
  ]

  form = this.fb.group({
    agendamento_funcionario: [[
      {
        posicao_ranking: 1,
        foto: null,
        nome_funcionario: "",
        nome_unidade: "",
        retornos: "",
        pagos: ""
      }
    ]],
    avaliacoes_antes_de_tres_horas: [[
      {
        posicao_ranking: 1,
        foto: null,
        nome_funcionario: "",
        porcentagem: ""
      },
    ]],
    entrega_de_exames: [[
      {
        posicao_ranking: 1,
        nome_unidade: '',
        total_entregas: '',
        entregas_por_funcionario: [
          {
            nome_funcionario: '',
            total_entregas_do_funcionario: ''
          }
        ]
      }
    ]],
    media_resolucoes_enviadas: [[
      {
        posicao_ranking: 1,
        nome_unidade: '',
        media_total_resolucoes: 0,
        total_resolucoes: '',
        resolucoes_por_funcionario: [
          {
            nome_funcionario: '',
            qtd_resolucoes: ''
          }
        ]
      },
    ]],
    relatorio_por_funcionario: [[
      {
        posicao_ranking: 1,
        nome_funcionario: "",
        agendamentos_feitos: "",
        avaliacoes_enviadas: "",
        exames_entregues: "",
        solicitacoes_finalizadas: ""
      }
    ]],
    total_relatorio_por_funcionario: {
      agendamentos_feitos: "",
      avaliacoes_enviadas: "",
      exames_entregues: "",
      solicitacoes_finalizadas: ""
    }
  })


  addFilterUnidade(name: string) {
    this.applyFilterUnidade = true
  }

  removeFilterUnidade() {
    this.applyFilterUnidade = false
  }

  addFilterUnidadeRelatorioFuncionario(name: string) {
    this.applyFilterUnidadeRelatorioFuncionario = true
  }
  removeFilterUnidadeRelatorioFuncionario() {
    this.applyFilterUnidadeRelatorioFuncionario = false
  }

  addFilterOptions(event: any) {
    console.log('event chegou: ', event)
  }

}
